<template>
  <span
    class="input-text"
    :class="{'input-text--with-unit': $slots.default, 'input-text--error': error}"
  >
  <input
    v-bind="$attrs"
    :type="type"
    class="input-text__input"
    v-model="localValue"
    autocomplete="off"
  />
    <span
      v-if="$slots.default"
      class="input-text__unit"
    >
      <slot/>
    </span>
  </span>
</template>

<script>
  import vueBind from '../../lib/vueBind';

  export default {
    props: {
      value: {
        type: [String, Number],
        default: '',
      },
      type: {
        type: String,
        default: 'text',
      },
      error: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      localValue: vueBind.vModel,
    },
  };
</script>

<style lang="scss">
  @import "~styles/definitions";

  .input-text {
    display: block;
    position: relative;
    background-color: #f7f7f7;
    transition: background-color 0.2s;

    &--error {
      background-color: $color-red-light;
    }
  }

  .input-text__input {
    @include reset-input(true);
    display: flex;
    align-items: center;
    height: r(40);
    width: 100%;
    padding: 0 r(8);
    transition: border-color 0.2s;
    background-color: $color-white;

    &:focus {
      outline: solid r(1) $color-green-2025;
    }

    .input-text--with-unit & {
      padding-right: r(48);
      text-align: right;
    }

    .input-text--error & {
      border-color: $color-red;
    }
  }

  .input-text--with-unit {
    min-width: 7rem;
  }

  .input-text__unit {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: r(48);
    font-weight: 700;
    line-height: 1;
    padding-right: .5rem;
  }
</style>
